import { buildAbsoluteUrl } from "./metadata";
import type { PageSeoMeta } from "./types";

export const OG_SITE_NAME = "Free Text Formatter";

export type SeoHeadElement = {
	type: "meta" | "link" | "script";
	props: Record<string, string>;
	children?: string;
};

export function buildSeoHeadElements(meta: PageSeoMeta, siteUrl: string): SeoHeadElement[] {
	const canonical = buildAbsoluteUrl(siteUrl, meta.canonicalPath);
	const image = meta.imagePath ? buildAbsoluteUrl(siteUrl, meta.imagePath) : "";
	const robots = meta.noindex ? "noindex,nofollow" : "index,follow";

	const elements: SeoHeadElement[] = [
		{ type: "meta", props: { name: "description", content: meta.description } },
		{ type: "link", props: { rel: "canonical", href: canonical } },
		{ type: "meta", props: { name: "robots", content: robots } },
		{ type: "meta", props: { property: "og:type", content: "website" } },
		{ type: "meta", props: { property: "og:site_name", content: OG_SITE_NAME } },
		{ type: "meta", props: { property: "og:title", content: meta.title } },
		{ type: "meta", props: { property: "og:description", content: meta.description } },
		{ type: "meta", props: { property: "og:url", content: canonical } },
		{ type: "meta", props: { name: "twitter:card", content: "summary_large_image" } },
		{ type: "meta", props: { name: "twitter:title", content: meta.title } },
		{ type: "meta", props: { name: "twitter:description", content: meta.description } },
	];

	if (image) {
		elements.push({ type: "meta", props: { property: "og:image", content: image } });
		elements.push({ type: "meta", props: { name: "twitter:image", content: image } });
	}

	if (meta.jsonLd) {
		elements.push({
			type: "script",
			props: { id: "seo-jsonld", type: "application/ld+json" },
			children: JSON.stringify(meta.jsonLd).replace(/<\//g, "<\\/"),
		});
	}

	return elements;
}
